import { PayablesSettings } from "../steps/PayrollSettings/PayablesSettings";
import { PayrollSchedule } from "../steps/PayrollSettings/PayrollSchedule";
import { OnboardingContext, OnboardingModulePayrollSettings } from "../types";
import { UseCreateOnboardingStep } from "../components/OnboardingFlowUtils";
import { usePayrollSettingsProgress } from "../hooks/usePayrollSettingsProgress";
import { FlowStep } from "../../../shared/components/FlowSwitch/types";

export const getPayrollSettingsStepConfig = (
  _: OnboardingModulePayrollSettings,
  __: OnboardingContext,
  isComplete?: boolean
): FlowStep => {
  const slug = "payroll-settings";

  const steps: FlowStep[] = [
    {
      title: "Payroll schedule",
      slug: "payroll-schedule",
      component: PayrollSchedule
    },
    {
      title: "Payables settings",
      slug: "payables-settings",
      component: PayablesSettings
    }
  ];

  return {
    title: "Payroll settings",
    slug,
    steps,

    status: isComplete ? "Complete" : "None",
    result: {
      Complete: {
        title: "Your payroll settings were saved",
        description:
          "The payroll settings your selected were saved. Click continue for the next step."
      }
    }
  };
};

export const usePayrollSettingsStep: UseCreateOnboardingStep<
  OnboardingModulePayrollSettings
> = () => {
  const { isComplete } = usePayrollSettingsProgress();

  // No query gates this module: both steps load their own data, and the module's
  // own status is the local progress flag, so there is nothing to show a loader
  // for and no `buildOnboardingStep` wrapper to add.
  return (onboardingModule, contextValue) =>
    getPayrollSettingsStepConfig(onboardingModule, contextValue, isComplete);
};
